import { connect } from 'react-redux';
import { getTranslation } from "../../../../reducers/common/localization";
import ValidateOrg from "./ValidateOrg";
import {
    fetchGetOrgDataForValidateById, fetchValidateOrg, getCurrentOrgId, getOrgDataToEdit, 
    loadingOrgs, onSetNextOrg, clearOrgData, fetchUpdateNotValidatedOrgGeneralData, fetchChangeAnchorBySysAdminForNotValidatedOrg
} from "../../../../reducers/organization/organizations";
import {
    getContinentsData, getCountriesData, getCurrentContinent,
    setCurrentContinent
} from "../../../../reducers/common/location";
import {resetSubmitFormData} from "../../../../reducers/common/submitForm";
import {
    showModal, MODAL_VALIDATE_PENDING_ORGANIZATION,
} from "../../../../reducers/common/activeModal";
import { setDefaultCurrencyAndPricingPreset } from "../../../../reducers/finance/finance";
import {getSubRoles} from "../../../../reducers/account/role";

const mapStateToProps = (state) => {
    return {
        id: getCurrentOrgId(state),
        data: getOrgDataToEdit(state),
        translation: getTranslation(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        loading: loadingOrgs(state),
        subRoles: getSubRoles(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onShowValidateOrgModal: () => {
            dispatch(showModal({ modalKey: MODAL_VALIDATE_PENDING_ORGANIZATION }));
        },
        onSetDefaultCurrencyAndPricingPreset: () => {
            dispatch(setDefaultCurrencyAndPricingPreset());
        },
        onLoadOrg: (id) => dispatch(fetchGetOrgDataForValidateById(id)),
        onSetContinent: (continentCode) => dispatch(setCurrentContinent(continentCode)),
        onValidate: (id) => dispatch(fetchValidateOrg(id)),
        onNext: () => dispatch(onSetNextOrg()),
        onUnmount: () => {
            dispatch(clearOrgData());
            dispatch(resetSubmitFormData());
            dispatch(setCurrentContinent(''));
        },
        onResetSubmitFormData: () =>  dispatch(resetSubmitFormData()),
        onUpdateGeneralData: (id, data) => dispatch(fetchUpdateNotValidatedOrgGeneralData(id, data)),
        onAnchorEdit: (id, data) => dispatch(fetchChangeAnchorBySysAdminForNotValidatedOrg(id, data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateOrg);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgModal/validateOrg/ValidateOrg.container.js